import React from 'react';
import axios from 'axios';
import classNames from 'classnames';
import { Select } from '@kmx/legos-react-select';
import { Form as AForm, InputGroup, TextField, Text, Modal } from '../../components';
import { Button } from '@kmx/legos-react-button';
import * as Validation from '../utils/validation';
import { stateOptions } from '../utils/fieldValues';
import { formatZip, formatCity, formatAddress } from '../utils/format';
import RequestType from '../constants/request-types';
import AppForm from '../constants/app-forms';

const invalidTerritories = ['PR', 'GU', 'VI', 'AS', 'MP'];

class AddressForm extends React.Component {
  constructor(props) {
    super(props);
    this.formType = AppForm.Address;
    this.state = {
      modalOpen: false,
      showInitialForm: true,
      stateError: false,
      formFields: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip5: '',
      },
      invalidFields: [],
      showAddressDropDown: true,
      smartAddresses: [],
      smartyStreetsError: false,
    };

    this.timer = null;
    this.formRef = React.createRef();
    this.selectRef = React.createRef();

    this.onSubmit = this.onSubmit.bind(this);
    this.onValidateHandler = this.onValidateHandler.bind(this);
    this.updateFormFields = this.updateFormFields.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.onModalOpen = this.onModalOpen.bind(this);
    this.updateStateField = this.updateStateField.bind(this);
    this.scrollTop = this.scrollTop.bind(this);
    this.setAddressItem = this.setAddressItem.bind(this);
    this.handleStateBlur = this.handleStateBlur.bind(this);
    this.handleAddressFocus = this.handleAddressFocus.bind(this);
    this.clickedOutside = this.clickedOutside.bind(this);
    this.updateAddressField = this.updateAddressField.bind(this);
    this.handleAddressBlur = this.handleAddressBlur.bind(this);
    this.renderAddressOptions = this.renderAddressOptions.bind(this);
    this.tabPressed = this.tabPressed.bind(this);
    this.escPressed = this.escPressed.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.clickedOutside);
    document.addEventListener('keydown', this.tabPressed);
    document.addEventListener('keydown', this.escPressed);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.clickedOutside);
    document.removeEventListener('keydown', this.tabPressed);
    document.removeEventListener('keydown', this.escPressed);
  }

  onSubmit() {
    this.setState({ modalOpen: false }, () => this.props.handleNextStep(this.formType, this.state.formFields));
  }


  escPressed(e) {
    if (this.node && this.state.showAddressDropDown && e.key === 'Escape') {
      this.setState({ showAddressDropDown: false });
    }
  }

  clickedOutside(e) {
    if (this.node && this.node.contains(e.target)) {
      return;
    }

    this.node && this.state.showAddressDropDown && this.setState({ showAddressDropDown: false });
  }

  tabPressed(e) {
    const hideDropDown = (e.key === 'Tab' || e.which === 9) && this.node && this.state.showAddressDropDown;
    if (hideDropDown) {
      this.setState({ showAddressDropDown: false });
    }
  }

  scrollTop() {
    window && window.scrollTo(0, 0);
  }

  setAddressItem(x) {
    this.setState({
      ...this.state,
      formFields: {
        ...this.state.formFields,
        address1: x.street_line,
        address2: x.secondary.length > 0 ? x.secondary : ' ', // UI will not update if the value is null or ""
        city: x.city,
        zip5: x.zipcode,
        state: x.state,
      },
      showAddressDropDown: false,
    });
  }

  onValidateHandler(invalidFields) {
    this.setState({ invalidFields });
  }

  handleAddressBlur() {
    this.state.showAddressDropDown && this.state.smartAddresses && document.getElementById('address1').focus();
  }

  setAddressReactState(suggestedAddresses) {
    const filtered = suggestedAddresses && suggestedAddresses.filter((add) => !invalidTerritories.includes(add.state));
    this.setState({ smartAddresses: filtered || null });
  }

  retrieveSmartAddresses(searchFor) {
    if (!window.useSmartyStreets || !window.smartyStreetsKey) {
return;
}

    const url =
      'https://us-autocomplete-pro.api.smartystreets.com/lookup?key=' + window.smartyStreetsKey + '&search=' + searchFor + '&max_results=5';
    return axios
      .get(url)
      .then(({ data }) => this.setAddressReactState(data.suggestions))
      .catch((error) => {
        const tooManyRequests = error.response.status === 429;
        this.setState({ showAddressDropDown: false, smartAddresses: null, smartyStreetsError: tooManyRequests });
      });
  }

  updateFormFields(Validation, e) {
    this.setState({
      formFields: {
        ...this.state.formFields,
        [e.target.name]: Validation,
      },
    });
  }

  updateAddressField(Validation, e) {
    this.setState({
      ...this.state,
      formFields: {
        ...this.state.formFields,
        [e.target.name]: Validation,
      },
      showAddressDropDown: true,
    });

    e.target.value.length >= 3 && !this.state.smartyStreetsError && this.retrieveSmartAddresses(e.target.value);
  }

  onModalClose(didAccept) {
    if (!didAccept) {
      this.setState({ modalOpen: false });
      this.scrollTop();
    } else {
      this.onSubmit();
    }
  }

  onModalOpen() {
    const { invalidFields } = this.state;
    const { requestType } = this.props;
    this.formRef.current.validate(true, () => {
      if (requestType === RequestType.Delete) {
        //show a modal if this is a delete request
        this.setState({ modalOpen: true });
        return;
      } 
      this.scrollTop();
      this.onSubmit();
    });
  }

  updateStateField(e) {
    this.setState({
      formFields: {
        ...this.state.formFields,
        state: e.target.value,
      },
    });
  }

  handleAddressFocus() {
    this.state.formFields.state && this.state.formFields.state.length >= 3 && this.setState({ showAddressDropDown: true });
  }

  handleStateBlur() {
    const { formFields } = this.state;
    const { state } = formFields;
    if (state == '') {
      this.setState({ stateError: true });
    } else {
      this.setState({ stateError: false });
    }
  }


  renderAddressOptions() {
    const { smartAddresses } = this.state;

    if (!smartAddresses || smartAddresses.length === 0) {
return null;
}

    return (
      <div className='type-ahead-list'>
        {smartAddresses.map((x, index) => {
          return (
            <div key={index} onClick={() => this.setAddressItem(x)} className='address-item'>
              <Text.Body1 className='m-t-0 fs-mask'>
                <span id='address1-list'>{x.street_line}</span>
                <span id='secondary-list'>{x.secondary}</span>
                <span id='city-list'>{x.city}</span>
                <span id='state-list'>{x.state}</span>
                <span id='zipcode-list'>{x.zipcode}</span>
              </Text.Body1>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { invalidFields, modalOpen, showInitialForm, showAddressDropDown } = this.state;
    const { formFields, stateError } = this.state;
    const { address1, address2, zip5, city, state } = formFields;
    const submitDisabled = invalidFields.length > 0 || this.state.formFields.state === '';
    const showDropdown = address1.length >= 3 && showAddressDropDown;

    return (
      <div className='address-form'>
        <AForm onValidate={this.onValidateHandler} ref={this.formRef}>
          <div className={classNames([{ fade: !showInitialForm }])}>
            {this.props.isThirdParty ? (
              <>
              <Text.Display3>Tell us about the person for whom you're submitting this request.</Text.Display3>
              <Text.Body1 className='m-b-l'>
              If the person currently resides at an <span className='attention-text'>international address</span>, please list the most recent
              address in the <span className='attention-text'>United States</span>.
            </Text.Body1>
            </>
            ) : null}
            {!this.props.isThirdParty && (
              <>
            <Text.Display3>Let&apos;s make sure we can identify you correctly</Text.Display3>        
            <Text.Body1 className='m-b-l'>
              If you currently reside at an <span className='attention-text'>international address</span>, please list your most recent
              address in the <span className='attention-text'>United States</span>.
            </Text.Body1>
            </>
            )}
            <div ref={(node) => (this.node = node)}>
              <InputGroup>
                <TextField
                  className='m-t-0 m-b-0 address1 fs-mask'
                  errorText='Enter a valid address 1'
                  onChange={this.updateAddressField}
                  label='Address line 1'
                  name='address1'
                  format={formatAddress}
                  required
                  value={address1}
                  onFocus={this.handleAddressFocus}
                  onBlur={this.handleAddressBlur}
                />
              </InputGroup>
              {showDropdown ? <>{this.renderAddressOptions()}</> : null}
            </div>
            <InputGroup>
              <TextField
                className='m-t-0 m-b-0 fs-mask'
                format={formatAddress}
                onChange={this.updateFormFields}
                label='Address line 2 (optional)'
                name='address2'
                id='address2'
                value={address2}
              />
            </InputGroup>

            <InputGroup>
              <TextField
                className='m-t-0 m-b-0'
                errorText='Enter a valid city'
                format={formatCity}
                onChange={this.updateFormFields}
                label='City'
                name='city'
                required
                value={city}
              />
            </InputGroup>

            <InputGroup>
              <div>
                <Select
                  ref={this.selectRef}
                  className={classNames(['state-selection', { 'state--error': stateError }])}
                  label='Select a State'
                  value={state}
                  options={stateOptions.sort((a) => (a.value === this.state.formFields.state ? -1 : 1))}
                  onChange={this.updateStateField}
                  onBlur={this.handleStateBlur}
                />
                {stateError ? <div className='kmx-text-field__error-text kmx-text-field__error-text--active state-error-text'>
                    Please select a State
                  </div> : null}
              </div>

              <TextField
                className='m-t-0 m-b-0 zip5'
                errorText='Enter a valid ZIP code'
                onChange={this.updateFormFields}
                maxLength={5}
                minLength={5}
                label='ZIP Code'
                name='zip5'
                format={formatZip}
                required
                validation={Validation.isValidZip}
                value={zip5}
              />
            </InputGroup>

            <Button className='kmx-button--full m-t-l' disabled={submitDisabled} level='primary' type='button' onClick={this.onModalOpen}>
              Submit
            </Button>
          </div>
        </AForm>
        <Modal
          acceptText='Continue'
          cancelText='Cancel'
          onClose={this.onModalClose}
          open={modalOpen}
          scrollable={false}
          title='Are you sure you want to delete your information?'>
          <Text.Body1>Once we delete your information, it cannot be undone.</Text.Body1>
        </Modal>
      </div>
    );
  }
}

export default AddressForm;
